<template>
  <div>
    <p>{{ canChangeProfile ? 'Your state profile is indicated below. Use the dropdown menu to switch to a different state.' : 'Your content profile is indicated below. Use this form to switch to a different profile.' }}</p>
    <div class="form-group">
      <label for="content-profile-selector">{{ canChangeProfile ? 'State' : 'Content Profile' }}</label>
      <select
        id="content-profile-selector"
        class="form-control"
        v-model="selectedProfileId">
        <option
          v-for="profile of profilesWithLabels"
          :value="profile.value"
          :key="profile.value">{{ profile.label }}</option>
      </select>
    </div>

    <div class="btn-toolbar">
      <button
        class="btn btn-primary btn-confirm"
        :disabled="!isConfirmEnabled"
        @click="confirmSelection">Confirm</button>
      <button class="btn btn-default btn-cancel" @click="cancelSelection">Cancel</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { domainToProfileIdOptionsMap } from '@/contentprofile/domain_content_profiles'
export default {
  name: 'ContentProfileSelector',
  props: {
    profileChoices: {
      type: Array,
      required: true
    },
    currentlyActiveProfileId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedProfileId: ''
    }
  },
  computed: {
    ...mapGetters('user', ['userDomainUuid']),
    ...mapGetters('visibility', ['canChangeProfile']),
    isDirty() {
      return this.currentlyActiveProfileId !== this.selectedProfileId
    },
    isConfirmEnabled() {
      return (this.selectedProfileId && this.isDirty) || false
    },
    getProfileOptionsForDomain() {
      if (!this.canChangeProfile) return this.profileChoices
      const allowed = domainToProfileIdOptionsMap[this.userDomainUuid]
      if (!Array.isArray(allowed)) return this.profileChoices
      const filtered = this.profileChoices.filter((p) => allowed.includes(p.id))
      if (filtered.length === 0) return this.profileChoices
      return filtered
    },
    profilesWithLabels() {
      return this.getProfileOptionsForDomain.map((p) => ({ ...p, label: p.name, value: p.id }))
    },
  },
  methods: {
    confirmSelection() {
      this.$emit('cpselect:confirmed', this.selectedProfileId)
    },
    cancelSelection() {
      this.selectedProfileId = this.currentlyActiveProfileId
      this.$emit('cpselect:canceled')
    }
  },
  created() {
    this.selectedProfileId = this.currentlyActiveProfileId
  }
}
</script>

<style scoped lang="less">
ul {
  margin-bottom: 32px;
}
</style>
